import { Component, OnInit } from '@angular/core';
import { RouterService } from '@app/routing/router.service';
import { ReturnAddress } from '@app/shared/return-to/return-address';
import { ReturnService } from '@app/shared/services/return.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'portal-return-to-link',
  templateUrl: './return-to-link.component.html',
  host: {
    class: 'return-to-link',
  },
  standalone: false,
})
export class ReturnToLinkComponent implements OnInit {
  public state$: Observable<ReturnAddress>;

  public currentRoute: string;

  constructor(
    private returnService: ReturnService,
    private routerService: RouterService
  ) {}

  public ngOnInit() {
    this.state$ = this.returnService.returnAddress$.pipe(untilDestroyed(this));
    this.currentRoute = this.routerService.currentRouteData.name;
  }
}
